import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTableColumnsType from "@/scenes/OrderManagement/enum/OrderTableColumnsType";
import OrderTableColumnsTypeNameMap from "@/scenes/OrderManagement/map/OrderTableColumnsTypeNameMap";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { Popover } from "antd";
import ResizableTableHead, { type ResizeHandleSide } from "./ResizableTableHead";
import ProductSettingGroup from "./ProductSettingGroup";

interface ProductTableHeadProps {
    shop?: ShopDTO;

    resizeHandleSide?: ResizeHandleSide;
}

const OrderListProductSetting = observer(function () {
    const { orderItemColumnSetting } = useOrderManagementStore().storage;

    return (
        <ProductSettingGroup
            selectedDisplayTypes={orderItemColumnSetting.selectedOrderItemDisplayTypes}
            picSize={orderItemColumnSetting.picSize}
            maxDisplayCount={orderItemColumnSetting.maxDisplayOrderItemCount}
            onDisplayTypesChange={(types) => orderItemColumnSetting.onDisplayTypesChange(types)}
            onPicSizeChange={(size) => orderItemColumnSetting.setPicSize(size)}
            onMaxDisplayCountChange={(count) => orderItemColumnSetting.setMaxDisplayCount(count)}
        />
    );
});

const ProductTableHead: React.FC<ProductTableHeadProps> = React.memo(function (props) {
    const { resizeHandleSide } = props;

    const orderManageStore = useOrderManagementStore();

    useEffect(() => {
        orderManageStore.storage.orderItemColumnSetting.getOrderItemDisplayData();
        orderManageStore.storage.orderItemColumnSetting.initMaxDisplayCount();
    }, []);

    return (
        <ResizableTableHead
            columnType={OrderTableColumnsType.PRODUCT}
            defaultWidth={190}
            resizeHandleSide={resizeHandleSide}
        >
            <div>
                <span>{OrderTableColumnsTypeNameMap[OrderTableColumnsType.PRODUCT]}</span>

                <Popover
                    content={() => <OrderListProductSetting />}
                    placement="bottomLeft"
                    classNames={{ root: "ec-product-setting-popover" }}
                    styles={{ content: { padding: "0" } }}
                >
                    <a
                        href="#"
                        className="ml5"
                        onClick={(e) => {
                            e.preventDefault();
                        }}
                    >
                        设置
                    </a>
                </Popover>
            </div>
        </ResizableTableHead>
    );
});

export default ProductTableHead;
